module.exports = __webpack_public_path__ + "media/assets/images/blog/redmine-small-0f9b0539100e116aa466fc056356e260.png";